/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('product-image-zoom').forEach((el) => {
    el.addEventListener('open', () => {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    });
    el.addEventListener('close', () => {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    });
  });
});
document.addEventListener('DOMContentLoaded', () => {
    const edd = document.querySelector('.edd-container');
    const buttons = document.querySelector('.product-form__buttons');

    if (edd && buttons) {
        buttons.insertAdjacentElement('afterend', edd);
    }
});

document.addEventListener('variant:change', (e) => {
  const edd = document.querySelector('.clickpost-edd__container');
  if (edd) edd.style.display = e.detail.variant?.available ? '' : 'none';
});

// initial state on load (no variant switch yet)
document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('[data-product-add-to-cart-button]');
  const edd = document.querySelector('.clickpost-edd__container');
  if (btn && edd) edd.style.display = btn.classList.contains('button--ternary') ? 'none' : '';
});
/* Fix: prevent mobile search/menu drawers from auto-closing
   because of background focus changes while the page is loading. */

(function () {
  function disableMobileDrawerFocusTrap() {
    const OpenableElement = customElements.get("openable-element");

    if (!OpenableElement) {
      return;
    }

    const prototype = OpenableElement.prototype;

    if (prototype.__mobileDrawerFocusTrapPatched) {
      return;
    }

    const originalDescriptor = Object.getOwnPropertyDescriptor(
      prototype,
      "shouldTrapFocus"
    );

    if (!originalDescriptor || !originalDescriptor.get) {
      return;
    }

    Object.defineProperty(prototype, "shouldTrapFocus", {
      configurable: true,
      get: function () {
        const isMobile = window.matchMedia(
          window.themeVariables?.breakpoints?.pocket || "(max-width: 999px)"
        ).matches;

        const isMobileDrawer =
          this.matches("mobile-navigation") ||
          this.matches("predictive-search-drawer");

        if (isMobile && isMobileDrawer) {
          return false;
        }

        return originalDescriptor.get.call(this);
      }
    });

    prototype.__mobileDrawerFocusTrapPatched = true;
  }

  if (customElements.get("openable-element")) {
    disableMobileDrawerFocusTrap();
  } else {
    customElements.whenDefined("openable-element").then(
      disableMobileDrawerFocusTrap
    );
  }
})();
/** MUF-10 Start*/
document.addEventListener('click', function (e) {
  var badge = e.target.closest('[data-quick-view-size-trigger]');
  if (!badge) return;

  var productItem = badge.closest('product-item');
  if (!productItem) return;

  var isPhone = window.matchMedia(window.themeVariables.breakpoints.phone).matches;
  var target = isPhone
    ? productItem.querySelector('quick-buy-popover')
    : productItem.querySelector('quick-buy-drawer');
  if (!target) return;

  var productUrl = badge.getAttribute('data-product-url');
  var variantId = badge.getAttribute('data-variant-id');
  target.setAttribute('href', productUrl + '?variant=' + variantId);
  target.open = true;
});
// MUF-10 End
/** MUF-09
 * Fix: Desktop Quick View (quick-buy-drawer) not closing on outside click / close button.
 * Lightweight, no dependencies — uses the theme's own OpenableElement `.open` property.
 */
(function () {
  var DESKTOP_QUERY = window.themeVariables.breakpoints.tabletAndUp; // 741px and up — matches "hidden-phone"

  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function getOpenDrawer() {
    return document.querySelector('quick-buy-drawer[open]');
  }

  // Close on click outside the drawer, or on its close (X) button
  document.addEventListener('click', function (e) {
    if (!isDesktop()) return;

    var drawer = getOpenDrawer();
    if (!drawer) return;

    var clickedClose = e.target.closest('[data-action="close"]');
    var clickedInside = e.target.closest('quick-buy-drawer');
    var clickedSizeChart = e.target.closest('[id*="size-chart"]');

    // Let the size-chart drawer/popover handle its own close first —
    // it lives outside quick-buy-drawer in the DOM (append-body), so
    // without this check every click on it also looked "outside".
    if (clickedSizeChart && !clickedInside) return;

    if (clickedClose || !clickedInside) {
      drawer.open = false;
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !isDesktop()) return;
    var drawer = getOpenDrawer();
    if (drawer) drawer.open = false;
  });
})();
/** Fix: Add to Cart inside desktop Quick View doesn't open the mini cart.
 * The theme skips auto-opening the mini cart whenever the add-to-cart form
 * is itself inside a `.drawer` — meant to avoid stacking two drawers — but
 * that also blocks it for the desktop Quick View, since quick-buy-drawer
 * itself has class "drawer". This restores it for that specific case only.
 */
document.addEventListener('cart:refresh', function (e) {
  if (!e.detail) return;
  var fromDesktopQuickView = e.target && e.target.closest && e.target.closest('quick-buy-drawer');
  if (fromDesktopQuickView && window.themeVariables.settings.cartType === 'drawer') {
    e.detail.openMiniCart = true;
  }
}, true); // capture phase — runs before the theme's own cart-drawer listener
// MUF-09 
